export type HotelServiceType = {
  readonly id: number;
  readonly name: string;
  readonly openingHoursRequired: boolean;
  readonly priceRequired: boolean;
  readonly priceKinds?: string[];
  readonly priority: number;
  readonly serviceKinds?: string[];
};

export function createHotelServiceType(values: unknown): HotelServiceType {
  const {
    id,
    name,
    openingHoursRequired,
    priceRequired,
    priceKinds,
    priority,
    serviceKinds,
  } = values as HotelServiceType;

  return {
    id,
    name,
    openingHoursRequired,
    priceRequired,
    priceKinds,
    priority,
    serviceKinds,
  };
}
